(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ft-faq-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const button=event.target.closest('[data-ft-faq-toggle]');if(!button)return;const panel=document.getElementById(button.getAttribute('aria-controls'));if(!panel)return;const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));panel.hidden=expanded;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ft-model-search-autocomplete"] && !Shopify.designMode) return;
  try {
    (() => {
    const modelMap = new Map([
      ['bc520', 'BC-520'],
      ['bc360', 'BC-360'],
      ['bx35', 'BX-35'],
      ['bx52', 'BX-52'],
      ['be52', 'BE-52'],
      ['be63', 'BE-63'],
      ['bp700', 'BP-700'],
      ['bp850', 'BP-850'],
      ['cs520', 'CS-520'],
      ['cs580', 'CS-580'],
      ['nwd178f', 'NWD-178F'],
      ['npp30', 'NPP-30']
    ]);
    const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const enhance = () => {
      document.querySelectorAll('input[type="search"], input[name="q"]').forEach((input) => {
        input.setAttribute('list', 'ft-model-search-options');
        const form = input.form;
        if (form && form.dataset.ftModelSearchReady !== 'true') {
          form.dataset.ftModelSearchReady = 'true';
          form.addEventListener('submit', () => {
            const match = modelMap.get(normalize(input.value));
            if (match) input.value = match;
          });
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhance, { once: true });
    } else {
      enhance();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ft-product-trust-specs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-ft-pincode-form]').forEach((form) => {
    const input = form.querySelector('[data-ft-pincode]');
    const submit = form.querySelector('[data-ft-pincode-submit]');
    const link = form.querySelector('[data-ft-pincode-link]');
    const result = form.querySelector('[data-ft-pincode-result]');
    const configNode = form.querySelector('[data-ft-pincode-config]');
    if (!input || !submit || !link || !result || !configNode) return;

    let config = {};
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }

    const messages = config.messages || {};
    const baseHref = link.href;
    const zoneAStates = ['rajasthan', 'delhi', 'haryana', 'uttar pradesh', 'punjab', 'madhya pradesh', 'gujarat', 'chandigarh', 'uttarakhand'];
    const zoneBStates = ['maharashtra', 'bihar', 'jharkhand', 'chhattisgarh', 'west bengal', 'odisha', 'karnataka', 'telangana', 'andhra pradesh', 'tamil nadu', 'kerala', 'goa', 'daman and diu', 'dadra and nagar haveli', 'dadra and nagar haveli and daman and diu', 'puducherry'];
    const zoneCStates = ['jammu and kashmir', 'ladakh', 'himachal pradesh', 'assam', 'sikkim', 'arunachal pradesh', 'nagaland', 'manipur', 'mizoram', 'tripura', 'meghalaya', 'andaman and nicobar', 'andaman and nicobar islands', 'lakshadweep'];

    const normalize = (value) => String(value || '').toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim();
    const listFromSetting = (value, normalizer = normalize) => String(value || '').split(',').map((item) => normalizer(item)).filter(Boolean);
    const excludedStates = listFromSetting(config.excludedStates);
    const excludedPrefixes = listFromSetting(config.excludedPrefixes, (value) => String(value || '').replace(/\D/g, '').trim());
    let debounceTimer;

    const updateHref = () => {
      const pin = input.value.replace(/\D/g, '').slice(0, 6);
      if (input.value !== pin) input.value = pin;
      link.href = pin ? `${baseHref}${encodeURIComponent(pin)}` : baseHref;
      return pin;
    };

    const setStatus = (status, message) => {
      if (!message) return;
      result.hidden = false;
      result.dataset.status = status;
      result.textContent = message;
    };

    const clearStatus = () => {
      result.hidden = true;
      result.removeAttribute('data-status');
      result.textContent = '';
    };

    const setLoading = (isLoading) => {
      form.classList.toggle('is-checking', isLoading);
      submit.disabled = isLoading;
      submit.setAttribute('aria-busy', String(isLoading));
    };

    const etaForState = (state) => {
      const normalizedState = normalize(state);
      if (zoneAStates.includes(normalizedState)) return messages.etaZoneA;
      if (zoneBStates.includes(normalizedState)) return messages.etaZoneB;
      if (zoneCStates.includes(normalizedState)) return messages.etaZoneC;
      return messages.etaDefault;
    };

    const formatMessage = (template, replacements) => Object.keys(replacements).reduce((message, key) => {
      const liquidPattern = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g');
      const bracePattern = new RegExp(`\\{\\s*${key}\\s*\\}`, 'g');
      return message.replace(liquidPattern, replacements[key]).replace(bracePattern, replacements[key]);
    }, template || '');

    const isExcluded = (pin, state) => {
      const normalizedState = normalize(state);
      return excludedStates.includes(normalizedState) || excludedPrefixes.some((prefix) => pin.startsWith(prefix));
    };

    const readCache = (pin) => {
      try {
        const cached = sessionStorage.getItem(`ft-pincode:${pin}`);
        return cached ? JSON.parse(cached) : null;
      } catch (error) {
        return null;
      }
    };

    const writeCache = (pin, value) => {
      try {
        sessionStorage.setItem(`ft-pincode:${pin}`, JSON.stringify(value));
      } catch (error) {
        // Session storage is an enhancement only.
      }
    };

    const fetchPincode = async (pin) => {
      const cached = readCache(pin);
      if (cached) return cached;

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), Number(config.timeoutMs) || 4000);

      try {
        const response = await fetch(`${config.apiBase}${encodeURIComponent(pin)}`, {
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('network');

        const payload = await response.json();
        const firstResult = Array.isArray(payload) ? payload[0] : null;
        const postOffice = firstResult && Array.isArray(firstResult.PostOffice) ? firstResult.PostOffice[0] : null;
        const lookup = firstResult && firstResult.Status === 'Success' && postOffice
          ? { status: 'success', district: postOffice.District || '', state: postOffice.State || '' }
          : { status: 'invalid' };

        writeCache(pin, lookup);
        return lookup;
      } catch (error) {
        return { status: 'fallback' };
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const runCheck = async () => {
      const pin = updateHref();
      if (pin.length !== 6) {
        setStatus('error', messages.invalid);
        return;
      }

      setLoading(true);
      setStatus('loading', messages.checking);

      const lookup = await fetchPincode(pin);
      setLoading(false);

      if (lookup.status === 'fallback') {
        setStatus('warning', messages.fallback);
        return;
      }

      if (lookup.status !== 'success') {
        setStatus('error', messages.invalid);
        return;
      }

      if (isExcluded(pin, lookup.state)) {
        setStatus('warning', messages.notServiceable);
        return;
      }

      const codMessage = config.codEnabled ? messages.codAvailable : messages.codConfirm;
      setStatus('success', formatMessage(messages.deliverable, {
        district: lookup.district,
        state: lookup.state,
        eta: etaForState(lookup.state),
        cod: codMessage
      }));
    };

    input.addEventListener('input', () => {
      const pin = updateHref();
      window.clearTimeout(debounceTimer);
      if (pin.length < 6) clearStatus();
      if (pin.length === 6) debounceTimer = window.setTimeout(runCheck, 450);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      window.clearTimeout(debounceTimer);
      runCheck();
    });
    submit.addEventListener('click', () => {
      window.clearTimeout(debounceTimer);
      runCheck();
    });
    link.addEventListener('click', updateHref);
  });
  } catch(e) { console.error(e); }
})();

})();
